module.exports = __webpack_public_path__ + "img/sld_scb_10_t1_b1_dark.018de39f.svg";